export default __webpack_public_path__ + "980ba9e0a862bec05b256f21e47f2119.png";